module.exports = __webpack_public_path__ + "static/media/plus.5e1c7c60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/Menu/assets/plus.svg
// module id = ./src/common/Menu/assets/plus.svg
// module chunks = 14